export var getElement = function (id) {
    var el = document.getElementById("app");
    if (el !== null)
        return el;
    else {
        var div = document.createElement("div");
        div.id = "app";
        document.body.prepend(div);
        return div;
    }
};
export var getUserData = function () {
    return { eventName: "Test", fullName: "Guilherme Baule", regId: "12313213213213" };
};
